import { useState } from "react";
import { Row, Col, Drawer } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import i18n from "i18next";
import Container from "../../common/Container";
import { SvgIcon } from "../../common/SvgIcon";
import { Button } from "../../common/Button";
import {
  HeaderSection,
  LogoContainer,
  Burger,
  NotHidden,
  Menu,
  CustomNavLinkSmall,
  Label,
  Outline,
  Span,
  LangContainer,
  LangButton,
  LangRowMobile,
  LangTitle,
} from "./styles";

const Header = ({ t }: { t: TFunction }) => {
  const [visible, setVisibility] = useState(false);

  const toggleButton = () => setVisibility((v) => !v);

  const changeLanguage = (lng: string, closeAfter = false) => {
    i18n.changeLanguage(lng);
    document.documentElement.lang = lng;
    if (closeAfter) setVisibility(false);
  };

  const scrollTo = (id: string) => {
    const element = document.getElementById(id) as HTMLDivElement | null;
    if (element) element.scrollIntoView({ behavior: "smooth" });
    setVisibility(false);
  };

  // Mobile (Drawer) mantém seu padrão antigo:
  const MenuItemMobile = () => (
    <>
      <CustomNavLinkSmall onClick={() => scrollTo("about")}>
        <Span>{t("About")}</Span>
      </CustomNavLinkSmall>
      <CustomNavLinkSmall onClick={() => scrollTo("mission")}>
        <Span>{t("Mission")}</Span>
      </CustomNavLinkSmall>
      <CustomNavLinkSmall onClick={() => scrollTo("product")}>
        <Span>{t("Purpose")}</Span>
      </CustomNavLinkSmall>
      <CustomNavLinkSmall
        style={{ width: "180px" }}
        onClick={() => scrollTo("contact")}
      >
        <Span>
          <Button>{t("Contact")}</Button>
        </Span>
      </CustomNavLinkSmall>
    </>
  );

  return (
    <HeaderSection>
      <Container>
        <Row justify="space-between" align="middle">
          <LogoContainer to="/" aria-label="homepage">
            <SvgIcon src="logo192.png" width="120px" height="120px" />
          </LogoContainer>

          {/* DESKTOP: itens + idioma entre Propósito e Contato */}
          <NotHidden>
            <CustomNavLinkSmall onClick={() => scrollTo("about")}>
              <Span>{t("About")}</Span>
            </CustomNavLinkSmall>
            <CustomNavLinkSmall onClick={() => scrollTo("mission")}>
              <Span>{t("Mission")}</Span>
            </CustomNavLinkSmall>
            <CustomNavLinkSmall onClick={() => scrollTo("product")}>
              <Span>{t("Purpose")}</Span>
            </CustomNavLinkSmall>

            {/* Idioma entre Propósito e Contato */}
            <LangContainer aria-label={t("Language")}>
              <LangButton onClick={() => changeLanguage("ch")}>
                <img src="/img/icons/china.png" alt="Chinese" />
              </LangButton>
              <LangButton onClick={() => changeLanguage("pt")}>
                <img src="/img/icons/brazil.png" alt="Português" />
              </LangButton>
              <LangButton onClick={() => changeLanguage("en")}>
                <img src="/img/icons/us.png" alt="English" />
              </LangButton>
            </LangContainer>

            <CustomNavLinkSmall
              style={{ width: "180px" }}
              onClick={() => scrollTo("contact")}
            >
              <Span>
                <Button>{t("Contact")}</Button>
              </Span>
            </CustomNavLinkSmall>
          </NotHidden>

          {/* Botão mobile */}
          <Burger onClick={toggleButton}>
            <Outline />
          </Burger>
        </Row>

        {/* SIDEBAR (Drawer) MOBILE: igual antes + idiomas no final */}
        <Drawer closable={false} open={visible} onClose={toggleButton}>
          <Col style={{ marginBottom: "2.5rem" }}>
            <Label onClick={toggleButton}>
              <Col span={12}>
                <Menu>Menu</Menu>
              </Col>
              <Col span={12}>
                <Outline />
              </Col>
            </Label>
          </Col>

          <MenuItemMobile />

          <LangRowMobile>
            <LangTitle>{t("Language")}</LangTitle>
            <LangContainer>
              <LangButton onClick={() => changeLanguage("ch", true)}>
                <img src="/img/icons/china.png" alt="Chinese" />
              </LangButton>
              <LangButton onClick={() => changeLanguage("pt", true)}>
                <img src="/img/icons/brazil.png" alt="Português" />
              </LangButton>
              <LangButton onClick={() => changeLanguage("en", true)}>
                <img src="/img/icons/us.png" alt="English" />
              </LangButton>
            </LangContainer>
          </LangRowMobile>
        </Drawer>
      </Container>
    </HeaderSection>
  );
};

export default withTranslation()(Header);
